class WishlistService {
    /*@ngInject*/
    constructor($log, $http, $rootScope, CommonService) {
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.commonService = CommonService;
        this.isLoggedInCustomer = false;
        this.productInWishlist = [];
        this.getWishlistEntries = null;
        this.productCodes = [];
        this.addToWishlistResponse = null;
        this.itemsQuantity = 0;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.isLoggedInCustomer = this.commonService.getPersonalizeRequestResponse().isHardLoggedIn;
            this.getWishListEntries = this.commonService.getPersonalizeRequestResponse().wishlistEntries;
            this.isInWishlist(this.productCodes);
            if (this.getWishListEntries != null) {
                this.itemsQuantity = this.getWishListEntries.length;
            }
        });

        $rootScope.$on('loadMoreProductsSuccess', () => {
            this.isInWishlist(this.productCodes);
        });

        this.$rootScope.$on('loadAlgoliaProductsSuccess', () => {
            this.isInWishlist(this.productCodes);
        });
    }

    isLoggedIn() {
        return this.isLoggedInCustomer;
    }

    setProductCodes(productCode) {
        this.productCodes.push(productCode);
    }

    isInWishlist(code) {
        if (this.getWishListEntries != null) {
            this.getWishListEntries.forEach((entry) => {
                if (code.includes(entry.code)) {
                    this.productInWishlist.push(entry.code);
                }
            });
        }
    }

    addToWishlist(code) {
        this.$log.debug('add to wishlist ' + code);
        let url = this.commonService.getBaseUrl() + '/wishlist/add?productCodePost=' + code;
        let req = {
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        };

        this.$http(req).then((response) => {
            this.addToWishlistResponse = response.data;

            if (this.addToWishlistResponse.result === 'SUCCESS') {
                this.itemsQuantity = this.itemsQuantity + 1;
                this.$rootScope.$broadcast('addedToWishlist', {code});
                //sending tracking data to dynamicYield LSEC-10515
                try {
                    if (typeof DY != 'undefined') {
                        DY.API('event', {
                            name: 'Add to Wishlist',
                            properties: {
                                dyType: 'add-to-wishlist-v1',
                                productId: code,
                            }
                        });
                    }
                } catch (error) {
                    this.$log.error('cant send DY add wishlist event: ' + code + ' ' + error.status + ' ' + error.statusText);
                }
            } else if (this.addToWishlistResponse.result === 'ERROR') {
                this.$rootScope.$broadcast('wishlistError');
            }
        }, (error) => {
            this.$log.error('add to wishlist: ' + error.status + ' ' + error.statusText);
            this.$rootScope.$broadcast('wishlistError');
        });
    }

    removeFromWishlist(code) {
        this.$log.debug('remove from wishlist ' + code);
        let url = this.commonService.getBaseUrl() + '/wishlist/delete?productCodePost=' + code;
        let req = {
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        };

        this.$http(req).then((response) => {
            this.removeFromWishlistResponse = response.data;
            if (this.removeFromWishlistResponse.result === 'SUCCESS') {
                this.itemsQuantity = this.itemsQuantity - 1;
                this.$rootScope.$broadcast('removedFromWishlist', {code});
            } else if (this.removeFromWishlistResponse.result === 'ERROR') {
                this.$rootScope.$broadcast('wishlistError');
            }
        }, (error) => {
            this.$log.error('remove from wishlist: ' + error.status + ' ' + error.statusText);
            this.$rootScope.$broadcast('wishlistError');
        });
    }

    getItemsQuantity() {
        return this.itemsQuantity;
    }

    setItemsQuantity(itemsQuantity) {
        this.itemsQuantity = itemsQuantity;
    }
}

export default WishlistService;
